function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#Expand_down_svg__clip0)"
}, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M.44 12.44a1.5 1.5 0 012.12 0L24 33.876l21.44-21.438a1.5 1.5 0 112.12 2.122L26.123 35.997a2.998 2.998 0 01-4.24.004L.438 14.56a1.5 1.5 0 010-2.122zM24 33.876zm0 0z"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "Expand_down_svg__clip0"
}, React.createElement("path", {
  d: "M0 0h48v48H0V0z"
})));

function SvgExpandDown(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    width: "1em",
    height: "1em"
  }, props), _ref, _ref2);
}

export default SvgExpandDown;